import { OPTION_HEIGHT_TW_CLASS_NAME } from '@components/option';

export const getOptionListStylesAsClassName = 'overflow-y-auto';

export const getOptionListHeightStyle = (maxVisibleOptions: number): number => {
  const twOptionHeight = OPTION_HEIGHT_TW_CLASS_NAME.split('-')[1];
  if (!twOptionHeight || isNaN(parseInt(twOptionHeight))) {
    throw new Error('Invalid OPTION_HEIGHT_TW_CLASS_NAME');
  }
  return parseInt(twOptionHeight) * 4 * maxVisibleOptions;
};
